export default __webpack_public_path__ + "static/media/watches13.d788c0b4.jfif";